import { createMap, forMember, mapFrom, mapWith } from "@automapper/core";
import { userLabelGroupTypeName, userLabelGroupViewModelTypeName, userLabelTypeName, userLabelViewModelTypeName } from "./constants.js";
class LabelMapping {
  createMapping(mapper) {
    createMap(
      mapper,
      userLabelGroupTypeName,
      userLabelGroupViewModelTypeName,
      forMember(
        (vm) => vm.id,
        mapFrom((m) => m.id)
      ),
      forMember(
        (vm) => vm.name,
        mapFrom((m) => m.name)
      ),
      forMember(
        (vm) => vm.color,
        mapFrom((m) => m.color)
      ),
      forMember(
        (vm) => vm.source_type,
        mapFrom((m) => m.source_type)
      )
    );
    createMap(
      mapper,
      userLabelTypeName,
      userLabelViewModelTypeName,
      forMember(
        (vm) => vm.id,
        mapFrom((m) => m.id)
      ),
      forMember(
        (vm) => vm.name,
        mapFrom((m) => m.name)
      ),
      forMember(
        (vm) => vm.group,
        mapWith(userLabelGroupViewModelTypeName, userLabelGroupTypeName, (m) => m.group)
      )
    );
  }
}
export {
  LabelMapping
};
//# sourceMappingURL=mapper.js.map
